<template>
  <CRow>
    <CCol col="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>Pengajuan Cuti</strong>
          </p>
        </template>
        <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #namaTanggalPengajuanCuti-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalPengajuanCuti" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #namaTanggalCuti-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalCuti" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #namaStatusPengajuan-filter>
                <b-form-select v-model="filter.statusPengajuan" :options="optionsStatusPengajuan"></b-form-select>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button
                    v-if="item.statusPengajuan == 0"
                    variant="success"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Approve Cuti'"
                    v-b-modal.modal-approve
                    @click="data = item"
                    :disabled="!['super', 'spv'].includes($store.state.role_aktif.kodeRole)"
                  >
                    <CIcon name="cil-check" />
                  </b-button>

                  <b-button
                    v-if="item.statusPengajuan == 0"
                    variant="danger"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Reject Cuti'"
                    v-b-modal.modal-reject
                    @click="data = item"
                    :disabled="!['super', 'spv'].includes($store.state.role_aktif.kodeRole)"
                  >
                    <CIcon name="cil-x" />
                  </b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <CCol col="12">
      <b-modal id="modal-approve" size="lg" centered scrollable title="Setujui Cuti" header-bg-variant="info" header-text-variant="light">
        <h4>
          Apakah anda yakin akan
          <span class="text-success">Menyetujui Pengajuan Cuti</span> a.n
          <span class="text-success">{{ data.namaKaryawan }}</span>
        </h4>

        <template #modal-footer>
          <b-button variant="secondary" @click="$bvModal.hide('modal-approve')"> Batal </b-button>
          <b-button variant="primary" @click="approve()" :disabled="busy"> Yakin </b-button>
        </template>
      </b-modal>
      <b-modal id="modal-reject" size="lg" centered scrollable title="Tolak Cuti" header-bg-variant="info" header-text-variant="light">
        <h4>
          Apakah anda yakin akan
          <span class="text-danger">Menolak Pengajuan Cuti</span> a.n
          <span class="text-danger">{{ data.namaKaryawan }}</span>
        </h4>

        <template #modal-footer>
          <b-button variant="secondary" @click="$bvModal.hide('modal-reject')"> Batal </b-button>
          <b-button variant="primary" @click="reject()" :disabled="busy"> Yakin </b-button>
        </template>
      </b-modal>
      <ModalInput :listKaryawan="listKaryawan" @alertFromChild="triggerAlert($event)" />
    </CCol>
  </CRow>
</template>

<script>
import ModalInput from "./modalAddCuti.vue";
export default {
  components: {
    ModalInput,
  },
  name: "pengajuanCuti",
  data() {
    return {
      busy: false,
      data: {},
      listKaryawan: [],
      items: [],

      filter: {
        tanggalPengajuanCuti: null,
        tanggalCuti: null,
        statusPengajuan: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      optionsStatusPengajuan: [
        { value: null, text: "Pilih" },
        { value: "0", text: "Menunggu Approval" },
        { value: "1", text: "Disetujui" },
        { value: "2", text: "Ditolak" },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      let x = [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          _style: "max-width: 25%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "NIK",
          label: this.$store.state.table.NIK,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalPengajuanCuti",
          label: this.$store.state.table.namaTanggalPengajuanCuti,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalCuti",
          label: this.$store.state.table.namaTanggalCuti,
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "totalCuti",
          label: this.$store.state.table.totalCuti,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaStatusPengajuan",
          label: this.$store.state.table.namaStatusPengajuan,
          _style: "max-width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "width: 10%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];

      if (this.$store.state.role_aktif.kodeRole == "super") {
        x.splice(1, 0, {
          key: "namaMitra",
          label: "Mitra",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        });
      }

      return x;
    },
  },
  mounted() {
    this.getDatas();
    this.getKaryawan();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalPengajuanCuti"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalCuti"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.statusPengajuan"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPengajuanCuti = await vm.$axios.post("pengajuanCuti/listPerHalaman", {
        ...vm.filter,
        tanggalPengajuanCuti: vm.filter.tanggalPengajuanCuti ? vm.$moment(vm.filter.tanggalPengajuanCuti).format("YYYY-MM-DD") : null,
        tanggalCuti: vm.filter.tanggalCuti ? vm.$moment(vm.filter.tanggalCuti).format("YYYY-MM-DD") : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      // console.log("listPengajuanCuti", listPengajuanCuti);
      vm.items =
        listPengajuanCuti.data.status == 200
          ? listPengajuanCuti.data.data.map((x, idx) => {
              vm.optionsStatusPengajuan.forEach((item) => {
                if (x.statusPengajuan == item.value) {
                  x.namaStatusPengajuan = item.text;
                }
              });
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.pengajuanCutiId,
                namaMitra: x.namaMitra || " - ",
                namaTanggalPengajuanCuti: vm.$moment(x.tanggalPengajuanCuti).format("LL"),
                namaTanggalCuti: vm.$moment(x.tanggalCuti).format("LL"),
              };
            })
          : [];
      vm.totalRows = parseInt(listPengajuanCuti.data.count);
      vm.loading = false;
    },
    async getKaryawan() {
      let vm = this;
      let listKaryawan = await vm.$axios.get("dataKaryawan/listKaryawan");
      vm.listKaryawan =
        listKaryawan.data.status == 200
          ? listKaryawan.data.data.map((x) => {
              return {
                ...x,
                namaKaryawan: x.namaKaryawan + " - " + x.penempatan,
              };
            })
          : [];
    },
    approve() {
      let vm = this;
      vm.data.id = vm.data.pengajuanCutiId;
      vm.data.statusPengajuan = 1;
      vm.$axios
        .post("pengajuanCuti/update", vm.data)
        .then((res) => {
          if (res.data.status == 200) {
            if (res.data.message == "sukses") {
              vm.$bvModal.hide("modal-approve");
              vm.$store.commit("set_alert", {
                showing: true,
                variant: "success",
                msg: "Berhasil Menyetujui Cuti",
              });
              vm.getDatas();
            } else {
              vm.$bvModal.hide("modal-approve");
              vm.$store.commit("set_alert", {
                showing: true,
                variant: "danger",
                msg: res.data.message.toUpperCase(),
              });
            }
          }
        })
        .catch((err) => {
          // console.log(err);
          vm.$bvModal.hide("modal-approve");
          vm.$store.commit("set_alert", {
            showing: true,
            variant: "danger",
            msg: err.data.message.toUpperCase(),
          });
        });
    },
    reject() {
      let vm = this;
      vm.data.id = vm.data.pengajuanCutiId;
      vm.data.statusPengajuan = 2;
      vm.$axios
        .post("pengajuanCuti/update", vm.data)
        .then((res) => {
          if (res.data.status == 200) {
            if (res.data.message == "sukses") {
              vm.$bvModal.hide("modal-reject");
              vm.$store.commit("set_alert", {
                showing: true,
                variant: "success",
                msg: "Berhasil Menolak Cuti",
              });
              vm.getDatas();
            } else {
              vm.$bvModal.hide("modal-reject");
              vm.$store.commit("set_alert", {
                showing: true,
                variant: "danger",
                msg: res.data.message.toUpperCase(),
              });
            }
          }
        })
        .catch((err) => {
          // console.log(err);
          vm.$bvModal.hide("modal-reject");
          vm.$store.commit("set_alert", {
            showing: true,
            variant: "danger",
            msg: err.data.message.toUpperCase(),
          });
        });
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
